import { PropsWithChildren } from 'react';
import Animated from '../animated/animated';
import styles from './page.module.css';

interface Props extends PropsWithChildren {
	title: string;
	onTitleClick?: React.MouseEventHandler<HTMLDivElement>;
	className?: string;
	titleClassName?: string;
}

export default function Page({ title, onTitleClick, children, className, titleClassName }: Props) {
	return (
		<div className={`${styles.component} ${className ?? ''}`}>
			<div className={`${styles.title} ${titleClassName ?? ''}`} onClick={onTitleClick}>
				<Animated>{title}</Animated>
			</div>
			<div className={styles.template}>{children}</div>
		</div>
	);
}
